module.exports = __webpack_public_path__ + "files/3b4e7fd31da14a405dfd80602cf38d00.svg";